import { useEffect } from 'react';
import { logmarData, logmarToSnellen } from '../../../helpers/data';
import { StartSizeList } from '../exams/StartSizeList';
import { useTestContext } from '../../../context/testContext';
import { PanelTitle, SessionActions, useAutoHideVideo } from '../../../ui';
import { StepBody } from '../testScreenKit';

// Step 2 - starting size. Figma: "Please select a starting logMAR"; the video strip is hidden here.
const ContrastSensitivitySetup = ({ eyeTested, updateStep }) => {
  const { setContrastSensitivityConfig, generateRandomCharacters, testData, updateTestData } = useTestContext();
  useAutoHideVideo();

  useEffect(() => {
    const initialCharacters = generateRandomCharacters().substring(0, 6);

    const contrastTestConfig = {
      logmar: testData[eyeTested],
      fontBrightness: 0,
      backgroundBrightness: 100,
      backgroundColor: 'hsl(0, 0%, 100%)',
      fontColor: 'hsl(0, 0%, 0%)',
      characters: initialCharacters,
    };

    setContrastSensitivityConfig(contrastTestConfig);
  }, [eyeTested, testData]);

  const rows = logmarData
    .filter((l) => l?.id >= testData.maxPermittedLogmar.id)
    .map((logmar) => ({ id: logmar.id, logmar, cells: [logmar.value.toFixed(1), logmarToSnellen[logmar.value.toFixed(1)]] }));

  return (
    <StepBody gap={16} data-testid='cs-start-size'>
      <PanelTitle small>Please select a starting logMAR</PanelTitle>
      <StartSizeList
        label='Starting logMAR'
        header={['logMAR', 'Snellen']}
        cols='1fr 1fr'
        mutedFrom={1}
        charsCol={-1}
        rows={rows}
        selectedId={testData[eyeTested]?.id}
        onSelect={(row) => updateTestData({ [eyeTested]: row.logmar })}
      />
      <SessionActions onBack={() => updateStep('eyeSetup')} primary={{ label: 'Next', onClick: () => updateStep(`${eyeTested}Test`), disabled: !testData[eyeTested] }} />
    </StepBody>
  );
};

export default ContrastSensitivitySetup;
